import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';

const SetItemSmalltxtBlock = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);
    const [itmVal, setItmVal] = useState(currentSingle[props.attrName]);

    useEffect(() => {
    }, [])

    const updateTheEffect = (attrName, e) => {
        const { name, value } = e.target;
        currentSingle[attrName] = e.target.value;
        setItmVal(e.target.value)
    }

    return (
        <div className={"col-md-6 mb-2 onRight"}>
            <label>{props.headTxt}</label>
            <div className={"input-group"}>
                <input type={"text"} name={itmVal} className={"form-control"}
                    id={"validationCustom02"} placeholder={props.placeholde}
                    value={currentSingle[props.attrName]} style={{ direction: "ltr" }}
                    onChange={(e) => { updateTheEffect(props.attrName, e); }} required />

            </div>
        </div>




    );
}

export default SetItemSmalltxtBlock;